// @flow
import styled from 'styled-components';

export const Container = styled.div`max-width: 25em;`;

export const Heading = styled.div`
    color: ${p => p.theme.secondaryHeavy};
    margin: 1em 0;
`;

export const Line = styled.hr`
    border: none;
    border-top: solid 1px ${p => p.theme.secondaryLight};
`;

export const Button = styled.div`
    align-items: center;
    display: flex;
    background-color: ${p => (p.selected ? p.theme.secondaryLight : 'transparent')};
    border: solid 1px transparent;
    border-color: ${p => (p.selected ? p.theme.mediumGrey : 'transparent')};
    border-radius: 1em;
    color: ${p => (p.selected ? p.theme.mainBrandColor : 'inherit')};
    cursor: pointer;
    font-size: 1.2em;
    height: 3em;
    justify-content: center;
    margin-top: 0.5em;
    transition: 0.3s;

    &:hover {
        background-color: ${p => p.theme.secondaryLight};
        box-shadow: ${p => (p.selected ? 'none' : `0 0 0.5em 0 ${p.theme.secondaryMedium}`)};
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/styles.js